import { Icon } from '@conexasaude/icons'
import { Text, getTheme } from '@conexasaude/conexa-hero'
import { useStyles } from './styles'
import { BackStepperProps } from './types'
import { RenderIf } from '@/components/RenderIf'
import useWindowSize from '@/utils/useWindowSize'

export const BackStepper: React.FunctionComponent<BackStepperProps> = ({
  onActionClick,
  showTextButton,
}) => {
  const styles = useStyles()
  const { isMobile } = useWindowSize()
  const theme = getTheme()

  return (
    <div css={styles.wrapper} onClick={onActionClick}>
      <Icon name="arrow-left" size="large" color={theme.colors.neutral[200]} />
      <RenderIf condition={isMobile || showTextButton}>
        <Text renderAs="span">Voltar</Text>
      </RenderIf>
    </div>
  )
}
